import { useReviewModesInfo } from "../api/reviewsApi";
import { REVIEW_MODES } from "../utils";

/** Opcje dropdowna trybu z nazwą modelu w etykiecie (fallback do statycznych). */
export function useReviewModeOptions() {
  const { data } = useReviewModesInfo();
  if (data && data.length > 0) {
    return data.map((m) => ({
      value: m.value,
      label: `${m.label} ${m.cost} · ${m.models}`,
    }));
  }
  return REVIEW_MODES.map((m) => ({ value: m.value, label: `${m.label} ${m.cost}` }));
}

/** Pod pickerem trybu: jakie modele, ich zaangażowanie (effort) i szacowany koszt. */
export function ReviewModeInfo({ mode }: { mode: string }) {
  const { data, isLoading } = useReviewModesInfo();
  const info = data?.find((m) => m.value === mode);
  if (isLoading && !info) {
    return (
      <p className="text-xs text-[var(--color-text-muted)]">Ładuję informacje o modelu…</p>
    );
  }
  if (!info) return null;
  return (
    <div className="text-xs border border-[var(--color-border)] bg-[var(--color-bg-elevated)] p-2 space-y-1">
      <p>
        <span className="text-[var(--color-text-muted)]">Modele:</span>{" "}
        <span className="font-medium text-[var(--color-text-primary)]">{info.models}</span>
      </p>
      <p>
        <span className="text-[var(--color-text-muted)]">Zaangażowanie:</span>{" "}
        <span className="text-[var(--color-text-secondary)]">{info.effort}</span>
      </p>
      <p>
        <span className="text-[var(--color-text-muted)]">Szacowany koszt:</span>{" "}
        <span className="text-[var(--color-text-secondary)]">
          ~${info.est_usd_per_100p} / 100 str. (orientacyjnie — zależy od liczby map i skanów)
        </span>
      </p>
    </div>
  );
}
